import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cdd00100-catarog-list" }
const _hoisted_2 = { class: "full-width row q-gutter-sm" }
const _hoisted_3 = { class: "q-pt-xs" }
const _hoisted_4 = { class: "flex" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import saveAs from 'file-saver';
import http from '../common/axios-common';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../common/code/ResultStatusCode';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';
import AlertDialog from '../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';

// 検索結果
interface Result {
  sdfOutZipId: number;
  category: string | null;
  version: string | null;
  itemCount: string | null;
  fileName: string;
  fileSize: string | null;
}

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*@__PURE__*/_defineComponent({
  __name: 'CDD00100',
  setup(__props) {

const columns: Array<any> = [
  {
    name: 'category',
    label: 'カテゴリー',
    align: 'left',
    field: 'category',
    required: true,
    sortable: true,
  },
  {
    name: 'version',
    label: 'Ver.',
    align: 'left',
    field: 'version',
    style: 'width: 40px',
    required: true,
    sortable: true,
  },
  {
    name: 'itemCount',
    label: '品目数',
    align: 'left',
    classes: 'text-right',
    field: 'itemCount',
    required: true,
    sortable: true,
    sort: (a: string, b: string) =>
      Number(a.split(/[^0-9]/g).join('')) - Number(b.split(/[^0-9]/g).join('')),
  },
  {
    name: 'fileName',
    label: 'ファイル名',
    align: 'left',
    field: 'fileName',
    required: true,
    sortable: true,
  },
  {
    name: 'fileSize',
    label: 'ファイルサイズ',
    align: 'left',
    classes: 'text-right',
    field: 'fileSize',
    required: true,
    sortable: true,
    sort: (a: string, b: string) =>
      Number(a.split(/[^0-9]/g).join('')) - Number(b.split(/[^0-9]/g).join('')),
  },
  {
    name: 'download',
    label: 'SDFile',
    field: 'download',
  },
];

// ダイアログのdisplayFlg(表示判断)
const dialogDisplayFlg = ref(false);

// ダイアログのlevel
const dialogLevel = ref('');

// ダイアログのtitle
const dialogTitle = ref('');

// ダイアログのtext
const dialogText = ref(['']);

// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(true);

// formData用ファイル名
const dowFileName = ref('');

// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// 取得したデータ
const data = ref<Array<Result>>([]);

// 表示するデータ
const rows = ref<Array<Result>>(data.value);

const router = useRouter();

/**
 * SDFile出力確認ダイアログ表示
 */
const displayOutExcelDialog = (fileName: string) => {
  dialogDisplayFlg.value = true;
  dialogConfFlg.value = false;
  dialogTitle.value = 'ダウンロード確認';
  dialogLevel.value = 'information';
  dialogText.value = ['カタログデータ（SDFile）をダウンロードします。', 'よろしいですか？'];
  dowFileName.value = fileName;
};

// 初期表示
const init = () => {
  // Loading Start
  Loading.show();
  http
    .post('/cdd001001/requestCatalog')
    .then((response) => {
      data.value = response.data.catalogList;
      rows.value = data.value;
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

// ダウンロード失敗ダイアログを表示
const mistakeSDFDialog = () => {
  // ダイアログ表示判断をtrue(表示)に変更
  dialogDisplayFlg.value = true;
  // ダイアログレベルを設定
  dialogLevel.value = 'error';
  // ダイアログのtitleを設定
  dialogTitle.value = 'ダウンロード失敗';
  // ダイアログのtextを生成
  dialogText.value = [`選択したカタログデータが存在しません。`];
  // キャンセルボタンを表示しない
  dialogConfFlg.value = true;
};

// SDFダウンロード
const downloadCatalog = () => {
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('fileName', dowFileName.value);

  http
    .post('/cdd001001/downloadCatalog', formData)
    .then((response) => {
      switch (response.data.common.status) {
        // 結果ステータス：正常終了
        case ResultStatusCode.SUCCESS:
          switch (response.data.common.detail_status) {
            // 詳細結果ステータス：正常終了
            case DetailResultStatusCode.SUCCESS:
              // SDFダウンロード
              saveAs(response.data.path, response.data.fileName);
              // ダイアログ表示
              dialogTitle.value = 'ダウンロード開始';
              dialogLevel.value = 'information';
              dialogText.value = [
                'カタログデータ（SDFile）のダウンロードを開始しました。',
                '※ファイルサイズが大きい場合、ダウンロードに時間がかかりますのでしばらくお待ちください。',
              ];
              dialogConfFlg.value = true;
              dialogDisplayFlg.value = true;
              break;
            // SDFダウンロード失敗ダイアログボックス表示
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              mistakeSDFDialog();
              break;
            default:
              break;
          }
          break;
        // 結果ステータス：異常終了
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
          break;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 初期表示
init();

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode("カタログデータダウンロード")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("p", null, [
        _createTextVNode(" ChemPandaに掲載している全品目のカタログデータ（SDFile）です。"),
        _createElementVNode("br"),
        _createTextVNode(" カテゴリー別にまとめたデータや、新商品のみをまとめたデータがダウンロード頂けます。 ")
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass('chem-table-area btn-exist ' + (rows.value.length === 0 ? 'table-nodata' : ''))
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: rows.value,
          columns: columns,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "rows-per-page": "20",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_3, _toDisplayString(message), 1)
            ])
          ]),
          "header-cell-download": _withCtx((val) => [
            _createVNode(_component_q_th, { class: "table-btn-area right-table-btn" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(val.col.label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell-download": _withCtx((cell) => [
            _createVNode(_component_q_td, { class: "table-btn-area right-table-btn" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_q_btn, {
                    icon: "mdi-download",
                    class: "export-btn",
                    color: "primary",
                    style: {"width":"150px"},
                    onClick: ($event: any) => (displayOutExcelDialog(cell.row.fileName))
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("ダウンロード")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["rows", "hide-no-data", "pagination-label"])
      ], 2)
    ]),
    _createVNode(AlertDialog, {
      display: dialogDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: dialogConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[0] || (_cache[0] = ($event: any) => (dialogDisplayFlg.value = false)),
      onConfirm: downloadCatalog,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (dialogDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})